import { mapState, mapActions, mapGetters } from 'vuex';
import axios from "axios";

function smthNamedPrefix(named, prefix, reverse){
    if(reverse) return prefix.toLowerCase() + named[0].toUpperCase() + named.substring(1)
    return named.toLowerCase() + prefix[0].toUpperCase() + prefix.substring(1)
}
function smthNamedSuffix(named, suffix){
    return suffix + named[0].toUpperCase() + named.substring(1)
}
function smthEmit(named, action){
    return named.toLowerCase()+"-"+action.toLowerCase();
}
function urlNamed(url, store){
    return store.toLowerCase() + "-" + url;
}

function emitsNamed(named){
    return [
        smthEmit(named, "open"),
        smthEmit(named, "close"),
        smthEmit(named, "click"),
        smthEmit(named, "dblclick"),
        smthEmit(named, "detail"),
        smthEmit(named, "remove-select"),
        smthEmit(named, "add-select"),
        smthEmit(named, "select"),
        smthEmit(named, "add"),
        smthEmit(named, "create"),
        smthEmit(named, "edit"),
        smthEmit(named, "custom"),
        smthEmit(named, "change"),
        smthEmit(named, "remove"),
        smthEmit(named, "reload"),
        smthEmit(named, "ready"),
        smthEmit(named, "action"),
        smthEmit(named+"s", "change"),
        smthEmit(named+"s", "reload"),
    ];
}

function watchNamed(named){
    return {
        [named]: {
            handler: smthNamedPrefix(named, "PropToLocal"),
            deep: true
        },
        [smthNamedPrefix(named, "Reload")]: {
            handler: smthNamedPrefix(named, "ReloadCurrentLoad"),
            deep: true
        },
        [smthNamedPrefix(named, "ListReload")]: {
            handler: smthNamedPrefix(named, "ReloadListLoad"),
            deep: true
        },
    }
}

function propsNamed(named){
    return {
        manage: { type: Boolean },
        [named]: { type: Object, default() { return {}; }},
        [named+"s"]: { type: Array, default() { return []; }},
        [smthNamedPrefix(named, "LoadLocally")]: { type: Boolean },
        [smthNamedPrefix(named, "Actions")]: { type: Array, default() { return []; }},
        [smthNamedPrefix(named, "Dispatch")]: { type: String, },
        [smthNamedPrefix(named, "PayloadOverride")]: { type: Object, default(){ return {}; }},
        [smthNamedPrefix(named, "Loading")]: { type: Boolean },
        //Actions
        [smthNamedPrefix(named, "Add")]: { type: Boolean },
        [smthNamedPrefix(named, "Remove")]: { type: Boolean },
        [smthNamedPrefix(named, "Edit")]: { type: Boolean },
        [smthNamedPrefix(named, "Detail")]: { type: Boolean },
        [smthNamedPrefix(named, "Select")]: { type: Boolean },
        [smthNamedPrefix(named, "Active")]: { type: Boolean },

        [smthNamedPrefix(named, "Addable")]: { type: Boolean },
        [smthNamedPrefix(named, "Removable")]: { type: Boolean },
        [smthNamedPrefix(named, "Editable")]: { type: Boolean },
        [smthNamedPrefix(named, "Detailable")]: { type: Boolean },
        [smthNamedPrefix(named, "Activeable")]: { type: Boolean },
        [smthNamedPrefix(named, "Selectable")]: { type: Boolean },
        // Current
        [smthNamedPrefix(named, "Emit")]: { type: Boolean },
        [smthNamedPrefix(named, "FieldUid")]: { type: String, default: "uid", },
        [smthNamedPrefix(named, "FieldNamedId")]: { type: String, default: "named_id", },
        [smthNamedPrefix(named, "UrlId")]: { type: String, default: smthNamedPrefix(named, "NamedId"), },
        [smthNamedPrefix(named, "NamedId")]: { type: String },
        //[smthNamedPrefix(named, "Uid")]: { type: String },
        [smthNamedPrefix(named, "DisableState")]: { type: Boolean },
        [smthNamedPrefix(named, "DisableProp")]: { type: Boolean },
        [smthNamedPrefix(named, "DisableLocal")]: { type: Boolean },
        [smthNamedPrefix(named, "Reload")]: { type: [Boolean, String, Date, Number] },
        // List
        [smthNamedPrefix(named, "Limit")]: { type: Number, default: 50 },
        [smthNamedPrefix(named, "Paginate")]: { type: Boolean },
        [smthNamedPrefix(named, "DisableListState")]: { type: Boolean },
        [smthNamedPrefix(named, "DisableListProp")]: { type: Boolean },
        [smthNamedPrefix(named, "DisableListLocal")]: { type: Boolean },
        [smthNamedPrefix(named, "ListApi")]: { type: Object },
        [smthNamedPrefix(named, "ListPayload")]: { type: Object },
        [smthNamedPrefix(named, "ListReload")]: { type: [Boolean, String, Date, Number] },
        [smthNamedPrefix(named, "ListSelected")]: { type: Array },
        // Card
        [smthNamedPrefix(named, "Header")]: { type: Boolean },
        [smthNamedPrefix(named, "Footer")]: { type: Boolean },
    }
}

function dataNamed(named){
    return {
        // Modals
        [smthNamedPrefix(named, "Modals")]: {
            create: false,
            edit: false,
            detail: false,
            delete: false,
            other: false,
            test: false,
        },
        [smthNamedPrefix(named, "OpenList")]: [],
        [smthNamedPrefix(named, "CloseList")]: [],
        [smthNamedPrefix(named, "Selection")]: [],
        [smthNamedPrefix(named, "ToEdit")]: {},
        [smthNamedPrefix(named, "ToCustom")]: {},
        [smthNamedPrefix(named, "ToDetail")]: {},
        [smthNamedPrefix(named, "ToRemove")]: {},
        [smthNamedPrefix(named, "Cancels")]: {},
        [smthNamedPrefix(named, "LibId")]: Math.random().toString(16).slice(2),
        [smthNamedPrefix(named, "Timer")]: 300,
        [smthNamedPrefix(named, "SubmitCounter")]: 0,
        [smthNamedPrefix(named, "ActionWait")]: undefined,
        [smthNamedPrefix(named, "Ready")]: false,
        [smthNamedPrefix(named, "Available")]: true,
        [smthNamedPrefix(named, "Loaded")]: false,
        [smthNamedPrefix(named, "ReloadCounter")]: 0,

        // List
        [smthNamedPrefix(named, "Local")]: {},
        [smthNamedPrefix(named, "ListLocal")]: [],
        [smthNamedPrefix(named, "ApiLocal")]: {},
        [smthNamedPrefix(named, "PayloadLocal")]: {},
    };
}

function stateNamed(named, store){
    var default_state = [
        smthNamedPrefix(named, "endpoint"),
        smthNamedPrefix(named, "endpoints"),
        smthNamedPrefix(named, "current"),
        smthNamedPrefix(named, "list"),
        smthNamedPrefix(named, "api"),
        smthNamedPrefix(named, "payload"),
    ]
    return mapState(store, default_state);
}

function gettersNamed(named, store){
    var default_getters = [
        smthNamedPrefix(named, "HTTP"),
        smthNamedPrefix(named, "ApiUrl"),
        smthNamedPrefix(named, "ApiUrlNamed"),
        smthNamedPrefix(named, "ByNamedId"),
        smthNamedPrefix(named, "ByUid"),
        smthNamedPrefix(named, "By"),
    ];
    return mapGetters(store, default_getters);
}

function computedNamed(named, store){
    return {
        ...stateNamed(named, store),
        ...gettersNamed(named, store),
        [smthNamedPrefix(named, "Current", true)](){
            return this[smthNamedPrefix(named, "current")];
        },

        [smthNamedPrefix(named, "Exists")](){
            return this[smthNamedPrefix(named+"s", "Load")].length;
        },
        [smthNamedPrefix(named, "Busy")](){
            return (!this[smthNamedPrefix(named, "Available")] || this[smthNamedPrefix(named, "Loading")]);
        },

        // Easy way to get dynamic data/props
        [smthNamedPrefix(named, "currentState")](){ return this[smthNamedPrefix(named, "current")]; },
        [smthNamedPrefix(named, "listState")](){ return this[smthNamedPrefix(named, "list")]; },
        [smthNamedPrefix(named, "listProp")](){ return this[named+"s"]; },
        [smthNamedPrefix(named, "ApiState")](){ return this[smthNamedPrefix(named, "Api")]; },
        [smthNamedPrefix(named, "ApiProp")](){ return this[smthNamedPrefix(named, "ListApi")]; },
        [smthNamedPrefix(named, "PayloadState")](){ return this[smthNamedPrefix(named, "payload")]; },
        [smthNamedPrefix(named, "inListState")](){
            return ((this[smthNamedPrefix(named, "listState")].length ||
                this.has(this[smthNamedPrefix(named, "ApiState")])) &&
                !this[smthNamedPrefix(named, "DisableListState")]);
        },
        [smthNamedPrefix(named, "inListProp")](){
            return ((this[smthNamedPrefix(named, "listProp")].length > 0 ||
                this.has(this[smthNamedPrefix(named, "ListApi")])) &&
                !this[smthNamedPrefix(named, "DisableListProp")]);
        },
        [smthNamedPrefix(named, "inListLocal")](){
            return ((this[smthNamedPrefix(named, "listLocal")].length > 0 ||
                this.has(this[smthNamedPrefix(named, "ApiLocal")])) &&
                !this[smthNamedPrefix(named, "DisableListLocal")]);
        },
        [smthNamedPrefix(named, "inState")](){
            return (this.has(this[smthNamedPrefix(named, "currentState")]) &&
                !this[smthNamedPrefix(named, "DisableState")]);
        },
        [smthNamedPrefix(named, "inProp")](){
            return (this.has(this[named]));
        },
        [smthNamedPrefix(named, "inLocal")](){
            return (this.has(this[smthNamedPrefix(named, "Local")]) &&
                !this[smthNamedPrefix(named, "DisableLocal")]);
        },
        [smthNamedPrefix(named, "InUrl")](){
            return this.$route.params[this[smthNamedPrefix(named, "UrlId")]];
        },
        [smthNamedPrefix(named, "IsLoad")](){
            return (this[smthNamedPrefix(named, "inLocal")] ||
                    this[smthNamedPrefix(named, "inProp")] ||
                    this[smthNamedPrefix(named, "inState")]
            );
        },

        // UID or named_id
        [smthNamedPrefix(named, "UsedUid")](){
            if(this[smthNamedPrefix(named, "IsLoad")])
                return this[smthNamedPrefix(named, "Load")][this[smthNamedPrefix(named, "FieldUid")]];
                return this[smthNamedPrefix(named, "inUrl")];
        },
        [smthNamedPrefix(named, "currentUid")](){ return this[smthNamedPrefix(named, "UsedUid")]; },
        [smthNamedPrefix(named, "UsedNamedId")](){
            if (this[smthNamedPrefix(named, "inLocal")] ||
                this[smthNamedPrefix(named, "inProp")] ||
                this[smthNamedPrefix(named, "inState")])
                return this[smthNamedPrefix(named, "Load")][this[smthNamedPrefix(named, "FieldNamedId")]];
            return this[smthNamedPrefix(named, "inUrl")];
        },
        [smthNamedPrefix(named, "currentNamedId")](){ return this[smthNamedPrefix(named, "UsedNamedId")];},

        // Default loader for needed (locally, props or globally in state)
        [smthNamedPrefix(named+"s", "Load")](){
            if(this[smthNamedPrefix(named, "inListLocal")]) return this[smthNamedPrefix(named, "listLocal")];
            else if(this[smthNamedPrefix(named, "inListProp")]) return this[smthNamedPrefix(named, "listProp")];
            else if(!this[smthNamedPrefix(named, "DisableListState")]) return this[smthNamedPrefix(named, "listState")];
            return [];
        },
        [smthNamedPrefix(named, "ApiLoad")](){
            if(this[smthNamedPrefix(named, "inListLocal")]) return this[smthNamedPrefix(named, "ApiLocal")];
            else if(this[smthNamedPrefix(named, "inListProp")]) return this[smthNamedPrefix(named, "ListApi")];
            else if(!this[smthNamedPrefix(named, "DisableListState")]) return this[smthNamedPrefix(named, "ApiState")];
            return [];
        },
        [smthNamedPrefix(named, "PayloadLoad")](){
            if(this[smthNamedPrefix(named, "inListLocal")]) return this[smthNamedPrefix(named, "PayloadLocal")];
            else if(this[smthNamedPrefix(named, "inListProp")]) return this[smthNamedPrefix(named, "ListPayload")];
            else if(!this[smthNamedPrefix(named, "DisableListState")]) return this[smthNamedPrefix(named, "PayloadState")];
            return [];
        },
        [smthNamedPrefix(named, "Load")](){
            if(this[smthNamedPrefix(named, "inLocal")]) return this[smthNamedPrefix(named, "Local")];
            else if(this[smthNamedPrefix(named, "inProp")]) return this[named];
            else if(!this[smthNamedPrefix(named, "DisableState")]) return this[smthNamedPrefix(named, "currentState")];
            return {};
        },
        [smthNamedPrefix(named, "Messages")](){
            return {
                cancel: named+": Operation canceled due to new request.",
                unknown: named+": Error unknown. We're sorry, you can use the support",
                error: named+": Error encountered. We're sorry, you can use the support",
            };
        },

        // Test view
        [smthNamedPrefix(named, "isUrlList")](){
            return (this.$route.name == named+"-list");
        },
        [smthNamedPrefix(named, "isUrlHome")](){
            return (this.$route.name == named+"-home");
        },
        [smthNamedPrefix(named, "isUrlDashboard")](){
            return (this.$route.name == named+"-dashboard");
        },
        [smthNamedPrefix(named, "isUrlManage")](){
            return (this.$route.name == named+"-manage");
        },
        [smthNamedPrefix(named, "isUrlConfig")](){
            return (this.$route.name == named+"-config");
        },
        [smthNamedPrefix(named, "isUrlDetail")](){
            return (this.$route.name == named+"-detail");
        },
        [smthNamedPrefix(named, "isUrlGuest")](){
            return (this.$route.name == named+"-guest");
        },
        [smthNamedPrefix(named, "isUrlEdit")](){
            return (this.$route.name == named+"-edit");
        },
        [smthNamedPrefix(named, "isUrlCreate")](){
            return (this.$route.name == named+"-create");
        },
        [smthNamedPrefix(named, "isUrlRemove")](){
            return (this.$route.name == named+"-remove");
        },
    }
}

function actionsNamed(named, store){
    var default_actions = [
        smthNamedPrefix(named, "setCurrent"),
        smthNamedPrefix(named, "getDetail"),
        smthNamedPrefix(named, "setDetail"),
        smthNamedPrefix(named, "reloadDetail"),
        smthNamedPrefix(named, "eraseDetail"),
        smthNamedPrefix(named, "getList"),
        smthNamedPrefix(named, "setList"),
        smthNamedPrefix(named, "reloadList"),
        smthNamedPrefix(named, "eraseList"),
        smthNamedPrefix(named, "create"),
        smthNamedPrefix(named, "update"),
        smthNamedPrefix(named, "delete"),
    ]
    return mapActions(store, default_actions);
}

function emitsNamedFCT(named){
    return {
        [smthNamedPrefix(named, "emitOpen")](data){ this.$emit(smthEmit(named, "open"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitClose")](data){ this.$emit(smthEmit(named, "close"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitClick")](data){ this.$emit(smthEmit(named, "click"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitDblclick")](data){ this.$emit(smthEmit(named, "dblclick"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitDetail")](data){ this.$emit(smthEmit(named, "detail"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitSelect")](data){ this.$emit(smthEmit(named, "select"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitAddSelect")](data){ this.$emit(smthEmit(named, "select"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitRemoveSelect")](data){ this.$emit(smthEmit(named, "select"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitCreate")](data){ this.$emit(smthEmit(named, "create"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitEdit")](data){ this.$emit(smthEmit(named, "edit"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitChange")](data){ this.$emit(smthEmit(named, "change"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitRemove")](data){ this.$emit(smthEmit(named, "remove"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitReload")](data){ this.$emit(smthEmit(named, "reload"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitReady")](data){ this.$emit(smthEmit(named, "ready"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitListChange")](data){ this.$emit(smthEmit(named+"s", "change"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitListReload")](data){ this.$emit(smthEmit(named+"s", "reload"), data ? data : this[smthNamedPrefix(named, "load")]); },
        [smthNamedPrefix(named, "emitOpenManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitOpen")](data); },
        [smthNamedPrefix(named, "emitCloseManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitClose")](data); },
        [smthNamedPrefix(named, "emitClickManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitClick")](data); },
        [smthNamedPrefix(named, "emitDblclickManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitDblclick")](data); },
        [smthNamedPrefix(named, "emitDetailManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitDetail")](data); },
        [smthNamedPrefix(named, "emitSelectManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitSelect")](data); },
        [smthNamedPrefix(named, "emitAddSelectManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitAddSelect")](data); },
        [smthNamedPrefix(named, "emitRemoveSelectManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitRemoveSelect")](data); },
        [smthNamedPrefix(named, "emitCreateManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitCreate")](data); },
        [smthNamedPrefix(named, "emitEditManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitEdit")](data); },
        [smthNamedPrefix(named, "emitChangeManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitChange")](data); },
        [smthNamedPrefix(named, "emitRemoveManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitRemove")](data); },
        [smthNamedPrefix(named, "emitReloadManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitReload")](data); },
        [smthNamedPrefix(named, "emitReadyManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitReady")](data); },
        [smthNamedPrefix(named, "emitListChangeManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitListChange")](data); },
        [smthNamedPrefix(named, "emitListReloadManage")](data){ if(this.manage) this[smthNamedPrefix(named, "emitListReload")](data); },
        [smthNamedPrefix(named, "emitAction")](action, data){
            this.$emit(smthEmit(named, "action"), { action: action, data: data ? data : this[smthNamedPrefix(named, "load")]});
        },
    };
}

function currentNamedFCT(named, store){
    return  {
        [smthNamedPrefix(named, "getCurrent")](uid){ return this[smthNamedPrefix(named, "getDetail")](uid); },
        async [smthNamedPrefix(named, "setCurrentLocal")](uid){
            this[smthNamedPrefix(named, "IsBusy")]();
            const field = this[smthNamedPrefix(named, "fieldUid")];
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "Local")][field];
            const response = await this[smthNamedPrefix(named, "getDetail")](uid);
            this[smthNamedPrefix(named, "Local")] = response.data;
            this[smthNamedPrefix(named, "emitChange")](this[smthNamedPrefix(named, "Local")]);
            this[smthNamedPrefix(named, "IsAvailable")]();
            return response;
        },
        async [smthNamedPrefix(named, "setCurrentState")](uid){
            this[smthNamedPrefix(named, "IsBusy")]();
            const field = this[smthNamedPrefix(named, "fieldUid")];
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "currentState")][field];
            const response = await this[smthNamedPrefix(named, "setDetail")](uid);
            this[smthNamedPrefix(named, "emitChange")](this[smthNamedPrefix(named, "currentState")]);
            this[smthNamedPrefix(named, "IsAvailable")]();
            return response;
        },
        [smthNamedPrefix(named, "reloadCurrentLocal")](){
            return this[smthNamedPrefix(named, "setCurrentLocal")](
                this[smthNamedPrefix(named, "Local")][this[smthNamedPrefix(named, "fieldUid")]]);
        },
        [smthNamedPrefix(named, "reloadCurrentState")](){
            return this[smthNamedPrefix(named, "setCurrentState")](
                this[smthNamedPrefix(named, "currentState")][this[smthNamedPrefix(named, "fieldUid")]]);
        },
        [smthNamedPrefix(named, "ReloadCurrentLoad")](){
            if(this[smthNamedPrefix(named, "inLocal")])
                return this[smthNamedPrefix(named, "reloadCurrentLocal")]();
            else if(!this[smthNamedPrefix(named, "DisableState")])
                return this[smthNamedPrefix(named, "reloadCurrentState")]();
            return {};
        },

        [smthNamedPrefix(named, "LoadByNamedId")](named_id){
            named_id = named_id != undefined ? named_id : this[smthNamedPrefix(named, "NamedId")];
            return this[smthNamedPrefix(named, "setCurrentLocal")](named_id);
        },
        [smthNamedPrefix(named, "LoadByUid")](uid){
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "Uid")];
            return this[smthNamedPrefix(named, "setCurrentLocal")](uid);
        },
        [smthNamedPrefix(named, "LoadByProp")](){
            if(this[smthNamedPrefix(named, "NamedId")]){
                const named_id = this[smthNamedPrefix(named, "NamedId")];
                return this[smthNamedPrefix(named, "LoadByNamedId")](named_id);
            }else if(this[smthNamedPrefix(named, "Uid")]){
                const uid = this[smthNamedPrefix(named, "Uid")];
                return this[smthNamedPrefix(named, "LoadByUid")](uid);
            }
        },


        // Erase
        [smthNamedPrefix(named, "EraseCurrentLocal")](){
            this[smthNamedPrefix(named, "Local")] = {};
        },
        [smthNamedPrefix(named, "EraseCurrentState")](){
            this[smthNamedPrefix(named, "EraseDetail")]();
        },
        async [smthNamedPrefix(named, "EraseCurrentLoad")](payload){
            var response = [];
            if(this[smthNamedPrefix(named, "inLocal")])
                response = await this[smthNamedPrefix(named, "EraseCurrentLocal")](payload);
            else if(!this[smthNamedPrefix(named, "DisableState")])
                response = await this[smthNamedPrefix(named, "EraseCurrentState")](payload);
            return response;
        },
        [smthNamedPrefix(named, "urlList")](){
            return { name:  this[smthNamedPrefix(named, "urlNamed")]("list", store, named) };
        },
        [smthNamedPrefix(named, "urlService")](service, named_id){
            named_id = named_id != undefined ? named_id : this[smthNamedPrefix(named, "currentNamedId")];
            var url = { name:  this[smthNamedPrefix(named, "urlNamed")](service, store, named) };
            if(named_id) url.params = {[smthNamedPrefix(named, "NamedId")]: named_id};
            return url;
        },
        [smthNamedPrefix(named, "urlHome")](named_id){
            named_id = named_id != undefined ? named_id : this[smthNamedPrefix(named, "currentNamedId")];
            return {
                name:  this[smthNamedPrefix(named, "urlNamed")]("home", store, named),
                params: {[smthNamedPrefix(named, "NamedId")]: named_id}
            };
        },
        [smthNamedPrefix(named, "urlDashboard")](named_id){
            return this[smthNamedPrefix(named, "urlService")]("dashboard", named_id);
        },
        [smthNamedPrefix(named, "urlManage")](named_id){
            named_id = named_id != undefined ? named_id : this[smthNamedPrefix(named, "currentNamedId")];
            return {
                name: this[smthNamedPrefix(named, "urlNamed")]("manage", store, named),
                params: {[this[smthNamedPrefix(named, "UrlId")]]: named_id}
            };
        },
        [smthNamedPrefix(named, "urlDetail")](named_id){
            named_id = named_id != undefined ? named_id : this[smthNamedPrefix(named, "currentNamedId")];
            return {
                name: this[smthNamedPrefix(named, "urlNamed")]("detail", store, named),
                params: {[this[smthNamedPrefix(named, "UrlId")]]: named_id}
            };
        },
        [smthNamedPrefix(named, "urlGuest")](named_id){
            named_id = named_id != undefined ? named_id : this[smthNamedPrefix(named, "currentNamedId")];
            return {
                name: this[smthNamedPrefix(named, "urlNamed")]("guest", store, named),
                params: {[this[smthNamedPrefix(named, "UrlId")]]: named_id}
            };
        },
        [smthNamedPrefix(named, "urlEdit")](named_id){
            named_id = named_id != undefined ? named_id : this[smthNamedPrefix(named, "currentNamedId")];
            return {
                name: this[smthNamedPrefix(named, "urlNamed")]("edit", store, named),
                params: {[this[smthNamedPrefix(named, "UrlId")]]: named_id}
            };
        },
        [smthNamedPrefix(named, "urlCreate")](){
            return {
                name: this[smthNamedPrefix(named, "urlNamed")]("create", store, named),
            };
        },
        [smthNamedPrefix(named, "urlRemove")](named_id){
            named_id = named_id != undefined ? named_id : this[smthNamedPrefix(named, "currentNamedId")];
            return {
                name: this[smthNamedPrefix(named, "urlNamed")]("Remove", store, named),
                params: {[this[smthNamedPrefix(named, "UrlId")]]: named_id}
            };
        },

        [smthNamedPrefix(named, "GoOnRole")](named_id){
            named_id = named_id != undefined ? named_id : this[smthNamedPrefix(named, "currentNamedId")];
            if(this.tenantHasRoleManager){
                this[smthNamedPrefix(named, "GoOnEdit")](named_id);
            }else{
                this[smthNamedPrefix(named, "GoOnGuest")](named_id);
            }
        },

        [smthNamedPrefix(named, "goOnList")](){
            this.$router.push(this[smthNamedPrefix(named, "urlList")]());
        },
        [smthNamedPrefix(named, "goOnDashboard")](named_id){
            this.$router.push(this[smthNamedPrefix(named, "urlDashboard")](named_id));
        },
        [smthNamedPrefix(named, "goOnManage")](named_id){
            this.$router.push(this[smthNamedPrefix(named, "urlManage")](named_id));
        },
        [smthNamedPrefix(named, "goOnDetail")](named_id){
            this.$router.push(this[smthNamedPrefix(named, "urlDetail")](named_id));
        },
        [smthNamedPrefix(named, "goOnGuest")](named_id){
            this.$router.push(this[smthNamedPrefix(named, "urlGuest")](named_id));
        },
        [smthNamedPrefix(named, "goOnEdit")](named_id){
            this.$router.push(this[smthNamedPrefix(named, "urlEdit")](named_id));
        },
        [smthNamedPrefix(named, "goOnRemove")](named_id){
            this.$router.push(this[smthNamedPrefix(named, "urlRemove")](named_id));
        },
        [smthNamedPrefix(named, "goOnPage")](data){
            this.$router.push(data);
        },
    };
}

function listNamedFCT(named){
    return {
        async [smthNamedPrefix(named, "AfterSetList")](response){
            return response;
        },
        async [smthNamedPrefix(named, "setListLocal")](payload){
            this[smthNamedPrefix(named, "IsBusy")]();
            payload = payload != undefined ? payload : {};
            this[smthNamedPrefix(named, "PayloadLocal")] = payload;
            var cancelID = this[smthNamedPrefix(named, "LibId")];
            payload = this[smthNamedPrefix(named, "PayloadGET")](payload, cancelID);
            var response = await this[smthNamedPrefix(named, "getList")](payload);
            response = await this[smthNamedPrefix(named, "AfterSetList")](response);
            if(this[smthNamedPrefix(named, "Paginate")]){
                this[smthNamedPrefix(named, "listLocal")] = response.data.results;
                delete response.data.results;
                this[smthNamedPrefix(named, "ApiLocal")] = response.data;
            }else{
                this[smthNamedPrefix(named, "listLocal")] = response.data;
            }
            this[smthNamedPrefix(named, "emitListChange")]();
            this[smthNamedPrefix(named, "IsAvailable")]();
            return response;
        },
        async [smthNamedPrefix(named, "setListState")](payload){
            this[smthNamedPrefix(named, "IsBusy")]();
            payload = payload != undefined ? payload : {};
            payload = this[smthNamedPrefix(named, "PayloadGET")](payload);
            var response = await this[smthNamedPrefix(named, "setList")](payload);
            response = await this[smthNamedPrefix(named, "AfterSetList")](response);
            this[smthNamedPrefix(named, "emitListChange")]();
            this[smthNamedPrefix(named, "IsAvailable")]();
            return response;
        },

        // Reload
        async [smthNamedPrefix(named, "ReloadListLocal")](payload, paginate){
            payload = payload != undefined ? payload : {};
            payload = Object.assign({}, this[smthNamedPrefix(named, "PayloadLocal")], payload);
            if(!paginate){
                delete payload.offset;
                delete payload.limit;
            }
            return await this[smthNamedPrefix(named, "setListLocal")](payload);
        },
        async [smthNamedPrefix(named, "ReloadListState")](payload, paginate){
            payload = payload != undefined ? payload : {};
            payload = Object.assign({}, this[smthNamedPrefix(named, "PayloadState")], payload);
            if(!paginate){
                delete payload.offset;
                delete payload.limit;
            }
            return await this[smthNamedPrefix(named, "SetListState")](payload);
        },
        async [smthNamedPrefix(named, "ReloadListLoad")](payload){
            var response = [];
            if(this[smthNamedPrefix(named, "inListLocal")])
                response = await this[smthNamedPrefix(named, "ReloadListLocal")](payload);
            else if(!this[smthNamedPrefix(named, "DisableListState")])
                response = await this[smthNamedPrefix(named, "ReloadListState")](payload);
            return response;
        },
        [smthNamedPrefix(named, "ReloadListLoadClearable")](payload){
            this[smthNamedPrefix(named, "ActionClearable")](
               smthNamedPrefix(named, "ReloadListLoad"), payload);
        },


        // Erase
        [smthNamedPrefix(named, "EraseListLocal")](){
            this[smthNamedPrefix(named, "ListLocal")] = [];
        },
        [smthNamedPrefix(named, "EraseListState")](){
            this[smthNamedPrefix(named, "EraseList")]();
        },
        async [smthNamedPrefix(named, "EraseListLoad")](payload){
            var response = [];
            if(this[smthNamedPrefix(named, "inListLocal")])
                response = await this[smthNamedPrefix(named, "EraseListLocal")](payload);
            else if(!this[smthNamedPrefix(named, "DisableListState")])
                response = await this[smthNamedPrefix(named, "EraseListState")](payload);
            return response;
        },

        // Paginator
        [smthNamedPrefix(named, "paramsPage")](page){return {
            offset: page*this[smthNamedPrefix(named, "Limit")],
            limit: this[smthNamedPrefix(named, "Limit")],
        };},
        [smthNamedPrefix(named, "goToPageLocal")](page){
            return this[smthNamedPrefix(named, "reloadListLocal")](
                this[smthNamedPrefix(named, "paramsPage")](page), true);
        },
        [smthNamedPrefix(named, "goToPageState")](page){
            return this[smthNamedPrefix(named, "reloadListState")](
                this[smthNamedPrefix(named, "paramsPage")](page), true);
        },
        [smthNamedPrefix(named, "goToPageLoad")](page){
            if(this[smthNamedPrefix(named, "inListLocal")])
                return this[smthNamedPrefix(named, "goToPageLocal")](page);
            if(!this[smthNamedPrefix(named, "DisableListState")])
                return this[smthNamedPrefix(named, "goToPageState")](page);
            return [];
        },
    }
}

function createNamedFCT(named){
    return {
        // STATE
        async [smthNamedPrefix(named, "createState")](payload){
            this[smthNamedPrefix(named, "IsBusy")]();
            var postPL = this[smthNamedPrefix(named, "PayloadPOST")](payload);
            postPL = Object.assign(this[smthNamedPrefix(named, "PayloadOverride")], postPL);
            const response = await this[smthNamedPrefix(named, "create")](postPL);
            this[smthNamedPrefix(named, "emitCreate")](response.data);
            this[smthNamedPrefix(named, "IsAvailable")]();
            return response;
        },
        async [smthNamedPrefix(named, "createStateCancellable")](payload){
            var postPL = this[smthNamedPrefix(named, "PayloadPOST")](payload);
            return await this[smthNamedPrefix(named, "createState")](postPL);
        },
        //LOCAL
        async [smthNamedPrefix(named, "CreateLocal")](payload){
            const response = await this[smthNamedPrefix(named, "createState")](payload);
            this[smthNamedPrefix(named, "Local")] = response.data;
            this[smthNamedPrefix(named, "emitCreate")](response.data);
            return response;
        },

        async [smthNamedPrefix(named, "createAndReload")](payload){
            await this[smthNamedPrefix(named, "CreateLocal")](payload);
            this[smthNamedPrefix(named, "ReloadListLoadClearable")]();
        }
    };
}

function updateNamedFCT(named){
    return {
        // STATE
        async [smthNamedPrefix(named, "updateState")]({ payload, uid }){
            this[smthNamedPrefix(named, "IsBusy")]();
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "currentState")][smthNamedPrefix(named, "fieldUid")];
            const response = await this[smthNamedPrefix(named, "update")]({uid, payload});
            this[smthNamedPrefix(named, "emitEdit")](this[smthNamedPrefix(named, "currentState")]);
            this[smthNamedPrefix(named, "IsAvailable")]();
            return response;
        },
        async [smthNamedPrefix(named, "updateStateCancellable")]({ payload, uid }){
            return await this[smthNamedPrefix(named, "updateState")]({
                payload: this[smthNamedPrefix(named, "PayloadPOST")](payload),
                uid: uid,
            });
        },
        [smthNamedPrefix(named, "editState")]({ payload, uid }){
            this[smthNamedPrefix(named, "updateState")]({ payload, uid });
        },
        [smthNamedPrefix(named, "editClearableState")](payload){
            this[smthNamedPrefix(named, "ActionClearable")](
                smthNamedPrefix(named, "updateState"), { payload});
        },

        // LOCAL
        async [smthNamedPrefix(named, "UpdateLocal")]({ payload, uid }){
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "Local")][smthNamedPrefix(named, "FieldUid")];
            const response = await this[smthNamedPrefix(named, "Update")]({uid, payload});
            this[smthNamedPrefix(named, "Local")] = response.data;
            this[smthNamedPrefix(named, "emitEdit")](this[smthNamedPrefix(named, "Local")]);
            return response;
        },
        async [smthNamedPrefix(named, "UpdateLocalCancellable")]({ payload, uid }){
            return await this[smthNamedPrefix(named, "UpdateLocal")]({
                payload: this[smthNamedPrefix(named, "PayloadPOST")](payload),
                uid: uid,
            });
        },
        [smthNamedPrefix(named, "EditLocal")]({ payload, uid }){
            return this[smthNamedPrefix(named, "UpdateLocal")]({ payload, uid });
        },
        [smthNamedPrefix(named, "EditClearableLocal")]({ payload, uid }){
            return this[smthNamedPrefix(named, "ActionClearable")](
                smthNamedPrefix(named, "UpdateLocal"), { payload, uid });
        },

        // PROP
        async [smthNamedPrefix(named, "updateProp")]({ payload, uid }){
            uid = uid != undefined ? uid : this[named][smthNamedPrefix(named, "fieldUid")];
            const response = await this[smthNamedPrefix(named, "update")]({uid, payload});
            this[smthNamedPrefix(named, "emitEdit")](this[named]);
            return response;
        },
        async [smthNamedPrefix(named, "updatePropCancellable")]({ payload, uid }){
            return await this[smthNamedPrefix(named, "updateProp")]({
                payload: this[smthNamedPrefix(named, "PayloadPOST")](payload),
                uid: uid,
            });
        },
        [smthNamedPrefix(named, "editProp")]({ payload, uid }){
            return this[smthNamedPrefix(named, "updateProp")]({ payload, uid });
        },
        [smthNamedPrefix(named, "editClearableProp")]({ payload, uid }){
            return this[smthNamedPrefix(named, "ActionClearable")](
                smthNamedPrefix(named, "updateProp"), { payload, uid });
        },

        // AUTO
        async [smthNamedPrefix(named, "updateLoad")]({ payload, uid }){
            this[smthNamedPrefix(named, "IsBusy")]();
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "UsedUid")];
            const response = await this[smthNamedPrefix(named, "update")]({uid, payload});
            if(this[smthNamedPrefix(named, "inLocal")])
                this[smthNamedPrefix(named, "Local")] = response.data;
            this[smthNamedPrefix(named, "IsAvailable")]();
            this[smthNamedPrefix(named, "emitEdit")](response.data);
            return response;
        },
        async [smthNamedPrefix(named, "updateLoadCancellable")]({ payload, uid }){
            return await this[smthNamedPrefix(named, "updateLoad")]({
                payload: this[smthNamedPrefix(named, "PayloadPOST")](payload),
                uid: uid,
            });
        },
        [smthNamedPrefix(named, "editLoad")]({ payload, uid }){
            return this[smthNamedPrefix(named, "updateLoad")]({ payload, uid });
        },
        [smthNamedPrefix(named, "editClearableLoad")]({ payload, uid }){
            return this[smthNamedPrefix(named, "ActionClearable")](
                smthNamedPrefix(named, "UpdateLoad"), { payload, uid });
        },
        async [smthNamedPrefix(named, "updateAndReload")](payload, uid){
            await this[smthNamedPrefix(named, "UpdateLoad")]({payload, uid});
            this[smthNamedPrefix(named, "ReloadListLoadClearable")]();
            this[smthNamedPrefix(named, "EraseToEdit")]();
        },
    };
}

function createOrUpdateFCT(named){
    return {
        // STATE
        async [smthNamedPrefix(named, "CreateOrUpdateState")](payload){
            const field_uid = this[smthNamedPrefix(named, "FieldUid")];
            if(payload[field_uid]) {
                this[smthNamedPrefix(named, "UpdateState")]({[field_uid]: payload[field_uid], payload});
            } else {
                this[smthNamedPrefix(named, "CreateState")](payload);
            }
        },
        async [smthNamedPrefix(named, "CreateOrUpdateStateCancellable")](payload){
            var postPL = this[smthNamedPrefix(named, "PayloadPOST")](payload);
            return await this[smthNamedPrefix(named, "CreateOrUpdateState")](postPL);
        },


        // LOCAL
        async [smthNamedPrefix(named, "CreateOrUpdateLocal")](payload){
            const field_uid = this[smthNamedPrefix(named, "fieldUid")];
            if(payload[field_uid]) {
                return await this[smthNamedPrefix(named, "UpdateLocal")]({[field_uid]: payload[field_uid], payload});
            } else {
                return await this[smthNamedPrefix(named, "CreateLocal")](payload);
            }
        },
        async [smthNamedPrefix(named, "CreateOrUpdateLocalCancellable")](payload){
            var postPL = this[smthNamedPrefix(named, "PayloadPOST")](payload);
            return await this[smthNamedPrefix(named, "CreateOrUpdateLocal")](postPL);
        },
    }
}

function removeNamedFCT(named){
    return {
        // STATE
        async [smthNamedPrefix(named, "RemoveState")](uid){
            this[smthNamedPrefix(named, "IsBusy")]();
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "currentState")][smthNamedPrefix(named, "fieldUid")];
            const response = await this[smthNamedPrefix(named, "delete")](uid);
            this[smthNamedPrefix(named, "IsAvailable")]();
            this[smthNamedPrefix(named, "emitRemove")](uid);
            return response;
        },

        //LOCAL
        async [smthNamedPrefix(named, "RemoveLocal")](uid){
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "Local")][smthNamedPrefix(named, "fieldUid")];
            const response = await this[smthNamedPrefix(named, "RemoveState")](uid);
            this[smthNamedPrefix(named, "Local")] = {};
            return response;
        },

        // PROP
        async [smthNamedPrefix(named, "RemoveProp")](uid){
            uid = uid != undefined ? uid : this[named][smthNamedPrefix(named, "fieldUid")];
            return await this[smthNamedPrefix(named, "RemoveState")](uid);
        },

        // AUTO
        async [smthNamedPrefix(named, "RemoveLoad")](uid){
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "currentUid")];
            return await this[smthNamedPrefix(named, "RemoveState")](uid);
        },
        async [smthNamedPrefix(named, "RemoveAndReload")](uid){
            await this[smthNamedPrefix(named, "RemoveLocal")](uid);
            this[smthNamedPrefix(named, "ReloadListLoadClearable")]();
            this[smthNamedPrefix(named, "EraseToRemove")]();
        }
    };
}

function methodsNamed(named, store){
    var actions = { ...actionsNamed(named, store) };
    var emits = emitsNamedFCT(named, store);
    var current = currentNamedFCT(named, store);
    var list = listNamedFCT(named, store);
    var create = createNamedFCT(named, store);
    var update = updateNamedFCT(named, store);
    var c_or_u = createOrUpdateFCT(named, store);
    var remove = removeNamedFCT(named, store);
    var others = {
        // Api URL
        [smthNamedPrefix(named, "ApiSfx")](suffix){
            var url = this[smthNamedPrefix(named, "ApiUrl")];
            return suffix ? url + suffix : url;
        },
        [smthNamedPrefix(named, "ApiUid")](uid){
            return uid ? this[smthNamedPrefix(named, "ApiSfx")](uid+"/") : undefined;
        },
        [smthNamedPrefix(named, "ApiForm")](suffix){
            var url = this[smthNamedPrefix(named, "ApiUrl")]+"form/";
            return suffix ? url + suffix : url;
        },
        [smthNamedPrefix(named, "ApiForms")](name, suffix){
            var url = this[smthNamedPrefix(named, "ApiUrl")]+"forms/" + name +"/";
            return suffix ? url + suffix : url;
        },
        [smthNamedPrefix(named, "ApiFormUid")](suffix, uid){
            uid = uid != undefined ? uid : this[smthNamedPrefix(named, "UsedUid")];
            var url = this[smthNamedPrefix(named, "ApiUrl")]+uid+"/form/";
            return suffix ? url + suffix : url;
        },

        // Modal
        [smthNamedPrefix(named, "OpenModal")](modal){
            this[smthNamedPrefix(named, "Modals")][modal] = true;
        },
        [smthNamedPrefix(named, "CloseModal")](modal){
            this[smthNamedPrefix(named, "Modals")][modal] = false;
        },

        // Form
        [smthNamedPrefix(named, "Submit")](i){
            i = i != undefined ? i : 1;
            this[smthNamedPrefix(named, "SubmitCounter")] = this[smthNamedPrefix(named, "SubmitCounter")]+i;
        },

        // Availability
        [smthNamedPrefix(named, "IsReady")](){
            this[smthNamedPrefix(named, "Ready")] = true;
        },
        [smthNamedPrefix(named, "IsBusy")](){
            this[smthNamedPrefix(named, "Available")] = false;
        },
        [smthNamedPrefix(named, "IsAvailable")](){
            this[smthNamedPrefix(named, "Loaded")] = true;
            this[smthNamedPrefix(named, "Available")] = true;
        },

        // Timer
        [smthNamedPrefix(named, "ActionClearable")](action, payload, timer) {
            timer = timer != undefined ? timer : this[smthNamedPrefix(named, "Timer")];
            clearTimeout(this[smthNamedPrefix(named, "ActionWait")]);
            this[smthNamedPrefix(named, "ActionWait")] = setTimeout(() => {
                if(payload)
                    this[action](payload);
                else
                    this[action]();
            }, timer);
        },

        // XHR
        [smthNamedPrefix(named, "CancelGET")](cancelID){
            var cancel = this[smthNamedPrefix(named, "Cancels")][cancelID];
            if(cancel){
                try{
                    cancel.cancel(this[smthNamedPrefix(named, "Messages")].cancel);
                }catch(error){
                    console.log(error);
                }
            }
        },
        [smthNamedPrefix(named, "PayloadGET")](payload, cancelID){
            payload = payload != undefined ? { params: payload } : {};
            if(cancelID != undefined){
                this[smthNamedPrefix(named, "CancelGET")](cancelID);
                const CancelToken = axios.CancelToken;
                this[smthNamedPrefix(named, "Cancels")][cancelID] = CancelToken.source();
                payload.cancelToken = this[smthNamedPrefix(named, "Cancels")][cancelID].token;
            }
            return payload;
        },
        [smthNamedPrefix(named, "CancelPOST")](cancelID){
            var cancel = this[smthNamedPrefix(named, "cancels")][cancelID];
            if(cancel){
                cancel.cancel(this[smthNamedPrefix(named, "messages")].cancel);
            }
        },
        [smthNamedPrefix(named, "PayloadPOST")](payload, cancelID){
            payload = payload != undefined ? { payload, config: {} } : {payload: {}, config: {}};
            if(cancelID != undefined){
                this[smthNamedPrefix(named, "CancelPOST")](cancelID);
                const CancelToken = axios.CancelToken;
                this[smthNamedPrefix(named, "cancels")][cancelID] = CancelToken.source();
                payload.config.cancelToken = this[smthNamedPrefix(named, "cancels")][cancelID].token;
            }
            return payload;
        },
        [smthNamedPrefix(named, "PropToLocal")](){
            if(this[smthNamedPrefix(named, "inProp")]){
                this[smthNamedPrefix(named, "Local")] = this[named];
            }
        },

        // helpers
        [smthNamedPrefix(named, "indexOpenList")](obj){
            const field = this[smthNamedPrefix(named, "FieldUid")];
            return this[smthNamedPrefix(named, "OpenList")].findIndex(el => el[field] == obj[field])
        },
        [smthNamedPrefix(named, "AddToOpenList")](obj){
            const index = this[smthNamedPrefix(named, "indexOpenList")](obj);
            if(index === -1) this[smthNamedPrefix(named, "OpenList")].push(obj);
        },
        [smthNamedPrefix(named, "RemoveToOpenList")](obj){
            const index = this[smthNamedPrefix(named, "indexOpenList")](obj);
            if(index > -1) this[smthNamedPrefix(named, "OpenList")].splice(index, 1);
        },
        [smthNamedPrefix(named, "EmitOpenList")](input){
            const obj = this[smthNamedPrefix(named, "Load")];
            if(input.value) this.$emit(smthEmit(named, "add-open-list"), obj);
            else this.$emit(smthEmit(named, "remove-open-list"), obj);
        },
        [smthNamedPrefix(named, "AddOrRemoveOpenlist")](input){
            const obj = this[smthNamedPrefix(named, "Load")];
            if(input.value) this[smthNamedPrefix(named, "AddToOpenList")](obj);
            else this[smthNamedPrefix(named, "RemoveToOpenList")](obj);
        },

        [smthNamedPrefix(named, "indexCloseList")](obj){
            const field = this[smthNamedPrefix(named, "FieldUid")];
            return this[smthNamedPrefix(named, "CloseList")].findIndex(el => el[field] == obj[field])
        },
        [smthNamedPrefix(named, "AddToCloseList")](obj){
            const index = this[smthNamedPrefix(named, "indexCloseList")](obj);
            if(index === -1) this[smthNamedPrefix(named, "named")].push(obj);
        },
        [smthNamedPrefix(named, "RemoveToCloseList")](obj){
            const index = this[smthNamedPrefix(named, "indexCloseList")](obj);
            if(index > -1) this[smthNamedPrefix(named, "named")].splice(index, 1);
        },
        [smthNamedPrefix(named, "EmitCloseList")](input){
            const obj = this[smthNamedPrefix(named, "Load")];
            if(input.value) this.$emit(smthEmit(named, "add-close-list"), obj);
            else this.$emit(smthEmit(named, "remove-close-list"), obj);
        },
        [smthNamedPrefix(named, "AddOrRemoveCloselist")](input){
            const obj = this[smthNamedPrefix(named, "Load")];
            if(input.value) this[smthNamedPrefix(named, "AddToCloseList")](obj);
            else this[smthNamedPrefix(named, "RemoveToCloseList")](obj);
        },

        [smthNamedPrefix(named, "indexSelected")](obj){
            const field = this[smthNamedPrefix(named, "FieldUid")];
            return this[smthNamedPrefix(named, "Selection")].findIndex(el => el[field] == obj[field])
        },
        [smthNamedPrefix(named, "AddToSelection")](obj){
            const index = this[smthNamedPrefix(named, "indexSelected")](obj);
            if(index === -1) this[smthNamedPrefix(named, "Selection")].push(obj);
        },
        [smthNamedPrefix(named, "RemoveToSelection")](obj){
            const index = this[smthNamedPrefix(named, "indexSelected")](obj);
            if(index > -1) this[smthNamedPrefix(named, "Selection")].splice(index, 1);
        },
        [smthNamedPrefix(named, "EmitSelectionCheckbox")](input){
            const obj = this[smthNamedPrefix(named, "Load")];
            if(input.value) this.$emit(smthEmit(named, "add-select"), obj);
            else this.$emit(smthEmit(named, "remove-select"), obj);
        },
        [smthNamedPrefix(named, "AddOrRemoveSelectionCheckbox")](input){
            const obj = this[smthNamedPrefix(named, "Load")];
            if(input.value) this[smthNamedPrefix(named, "AddToSelection")](obj);
            else this[smthNamedPrefix(named, "RemoveToSelection")](obj);
        },

        [smthNamedPrefix(named, "AddToDetail")](obj){
            this[smthNamedPrefix(named, "ToDetail")] = obj;
        },
        [smthNamedPrefix(named, "EraseToDetail")](){
            this[smthNamedPrefix(named, "ToDetail")] = {};
        },
        [smthNamedPrefix(named, "AddToRemove")](obj){
            this[smthNamedPrefix(named, "ToRemove")] = obj;
        },
        [smthNamedPrefix(named, "EraseToRemove")](){
            this[smthNamedPrefix(named, "ToRemove")] = {};
        },
        [smthNamedPrefix(named, "AddToEdit")](obj){
            this[smthNamedPrefix(named, "ToEdit")] = obj;
        },
        [smthNamedPrefix(named, "EraseToCustom")](){
            this[smthNamedPrefix(named, "ToCustom")] = {};
        },
        [smthNamedPrefix(named, "AddToCustom")](obj){
            this[smthNamedPrefix(named, "ToCustom")] = obj;
        },
        [smthNamedPrefix(named, "EraseToEdit")](){
            this[smthNamedPrefix(named, "ToEdit")] = {};
        },
        [smthNamedPrefix(named, "EraseToAll")](){
            this[smthNamedPrefix(named, "EraseToEdit")]();
            this[smthNamedPrefix(named, "EraseToRemove")]();
            this[smthNamedPrefix(named, "EraseToDetail")]();
            this[smthNamedPrefix(named, "EraseToCustom")]();
        },


        async [smthNamedPrefix(named, "CRUDandReload")](){
            this[smthNamedPrefix(named, "ReloadListLoadClearable")]();
            this[smthNamedPrefix(named, "EraseToAll")]();
        },


        // Shortcuts
        [smthNamedPrefix(named, "smthNamedPrefix")](named, prefix){
            return smthNamedPrefix(named, prefix);
        },
        [smthNamedPrefix(named, "smthNamedSuffix")](named, suffix){
            return smthNamedSuffix(named, suffix);
        },
        [smthNamedPrefix(named, "urlNamed")](url, store, named){
            return urlNamed(url, store, named);
        },

    }
    return Object.assign({},
        actions,
        emits,
        current,
        list,
        create,
        update,
        c_or_u,
        remove,
        others
    );
}

export default function setupLibBackend(named, store) {
    return {
        data: () => dataNamed(named, store),
        emits: emitsNamed(named, store),
        watch: watchNamed(named, store),
        props: propsNamed(named, store),
        computed: computedNamed(named, store),
        methods: methodsNamed(named, store),
    }
}
